export const handleAudioSeekShortcuts = (
  evt: KeyboardEvent,
  playNext: () => void,
  playPrev: () => void,
) => {
  if (!evt.shiftKey) {
    return;
  }

  switch (evt.key) {
    case 'ArrowLeft':
      return playPrev();
    case 'ArrowRight':
      return playNext();
  }
};
